import ErrorBoundary from '@/components/ErrorBoundary';
import { StandaloneNavigationProps } from '@/components/layout/Navigation';
import { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { standaloneComponent } from 'modules/dynamic-components';
import { ReactNode } from 'react';
import { StandaloneFooterProps } from '../Footer';
import { StandaloneMainProps } from '../Main';

const Navigation = standaloneComponent<StandaloneNavigationProps>('LayoutNavigation');
const Footer = standaloneComponent<StandaloneFooterProps>('LayoutFooter');
const Main = standaloneComponent<StandaloneMainProps>('LayoutMain');

export interface StandaloneLayoutProps extends StandaloneComponentProps {
  content?: ReactNode;
  options?: {
    $navigation?: StandaloneNavigationProps;
    $main?: StandaloneMainProps;
    $footer?: StandaloneFooterProps;
  };
}

const StandaloneLayoutBase: StandaloneComponent<StandaloneLayoutProps> = ({ content, options }) => {
  const { $navigation, $main, $footer } = { ...options };

  return (
    <ErrorBoundary>
      <Navigation {...$navigation} />
      <Main content={content} {...$main} />
      <Footer {...$footer} />
    </ErrorBoundary>
  );
};

export const standalone = StandaloneLayoutBase;

const LabradorLayoutBase: LabradorComponent = () => <StandaloneLayoutBase />;

export default LabradorLayoutBase;
